
jQuery(document).ready(function($) {

    const carouselFeatured = $("#carousel-testimonials").owlCarousel({
        items:1,
        mouseDrag: false,
        nav: false,
        dots: true,
        autoplay: false,
        autoplayHoverPause: false,
        smartSpeed: 600,
        dotsSpeed: 270,
        loop: true,
        margin: 32,
    });

});